export default __webpack_public_path__ + "static/media/drone.e28f2b79.png";